import { nanoid } from "nanoid";
import { NoteId } from "../../shared/types";

export const generateId = (): NoteId => {
  return nanoid(10);
};
